import { useUser } from '@lore/auth';
import { PayloadStates } from '@lore/utils';
import { useConnect } from '../../hooks/@lore/query-connect';

export default function useNetworks(props) {
  const currentUser = useUser();

  return useConnect('network.find', {
    where: {
      eager: {
        $where: {
          isActive: true,
          networkSites: {
            $where: {
              $or: [
                // is within 50 miles of a site in this network
                {
                  userSites: {
                    $where: {
                      userId: currentUser.id
                    }
                  }
                },
                // is linked to a site in this network
                {
                  roles: {
                    $where: {
                      userId: currentUser.id
                    }
                  }
                }
              ]
            }
          }
        }
      }
    }
  });
};
